<template>
  <div>
    <base-card :option="cardOption">
      <div slot="cardBody">
        <search-form @setSearchCondition="setSearchCondition" @clearSearch="clearSearch"></search-form>
        <!--      操作按钮-->
        <div class="table-operator">
          <a-button type="default" :disabled="!isEdit" v-action:addUser icon="plus" @click="handleAdd">添加人员</a-button>
          <a-button icon="delete" v-action:deleteUser @click="handleDel">批量移除</a-button>
        </div>
        <!--表格-->
        <a-table
          :columns="table.columns"
          :rowKey="record => record.userId"
          :dataSource="table.data"
          :pagination="pagination"
          :loading="table.listLoading"
          @change="handleTableChange"
          :rowSelection="rowSelection"
        >
          <!--filterDropdown-->
          <template slot="actions" slot-scope="text, record">
            <a-popconfirm
              v-if="table.data.length"
              :title="`确定要移除【${record.userName}】吗?`"
              @confirm="() => onDelete(record)"
            >
              <a v-action:deleteUser href="javascript:;">移除</a>
            </a-popconfirm>
          </template>

        </a-table>
      </div>
    </base-card>
    <!--各种弹出组件-->
    <edit-modal ref="editModal" @refreshTable="initTableData"></edit-modal>
  </div>
</template>

<script>
import { getUserList, deleteGroupUser } from '@/api/group'
import editModal from './editModal'
import searchForm from './searchForm'
import baseCard from '@/CrComponents/Card/Card'
export default {
  name: 'ListModel',
  mounted () {
    // this.searchModel = { ...this.pagination }
    // this.initTableData()
  },
  computed: {
    groupId () {
      return this.$store.state.group.groupId
    },
    groupName () {
      return this.$store.state.group.groupName
    },
    isEdit () {
      return this.groupId !== 0
    }
  },
  components: {
    editModal,
    searchForm,
    baseCard
  },
  data () {
    return {
      // card相关属性设置
      cardOption: {},
      // 搜索form中的参数
      searchFormModel: {},
      // 所有搜索条件 包括分页，搜素框，表格上筛选条件
      searchModel: {},
      // 表格中的查询条件
      searchTableModel: {},
      // 高级搜索 展开/关闭
      searchInput: null,
      searchText: '',
      selectedRows: [],
      rowSelection: {
        selectedRowKeys: [],
        onChange: (selectedRowKeys, selectedRows) => {
          this.rowSelection.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectedRows = selectedRows
        }
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      },
      table: {
        data: [],
        columns: [{
          title: '名称',
          dataIndex: 'userName'

        }, {
          title: '编号',
          dataIndex: 'userNumber'

        },
        {
          title: '角色',
          dataIndex: 'roleNames'
        },
        {
          title: '操作',
          scopedSlots:
                {
                  customRender: 'actions'
                }
        }],
        searchCondition: {},
        listLoading: false,
        filteredInfo: null,
        sortedInfo: null
      },
      // 批量移除确认框
      visible: false
    }
  },
  methods: {
    // 搜索
    setSearchCondition (searchFormModel) {
      this.searchFormModel = searchFormModel
      this.searchModel = { ...this.pagination, ...this.searchTableModel, ...searchFormModel }
      this.initTableData()
    },
    // 重置
    clearSearch (searchFormModel) {
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchFormModel = searchFormModel
      this.searchModel = { ...this.pagination, ...this.searchTableModel }
      this.table.filteredInfo = null
      this.table.sortedInfo = null
      delete this.searchModel.sortField
      delete this.searchModel.sortOrder
      this.initTableData()
    },
    // 表格中的搜索
    handleSearch (selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    // 表格中的重置
    handleReset (clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    // 初始化表格数据
    initTableData () {
      this.searchFormModel.groupId = this.groupId
      this.searchModel = { ...this.pagination, ...this.searchTableModel, ...this.searchFormModel }
      this.table.listLoading = true
      console.log('listModel', this.searchModel)
      getUserList(this.searchModel).then(res => {
        if (res.status === 0) {
          this.table.listLoading = false
          this.table.data = res.data.list
          this.pagination.total = res.data.total
          // 清空已选项绑定key值
          this.rowSelection.selectedRowKeys = []
        } else {
          this.$message.error('获取数据失败！')
        }
      })
    },
    // 清空表格数据
    clearTableData () {
      this.table.data = []
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.table.filteredInfo = filters
      this.table.sortedInfo = sorter
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      this.searchModel = {
        ...this.searchFormModel,
        ...this.pagination,
        ...this.searchTableModel,
        sortField: sorter.field,
        sortOrder: sorter.order
      }
      this.initTableData()
    },
    // 移除操作
    onDelete (model) {
      const params = {
        groupId: this.groupId,
        userIds: model.userId
      }

      deleteGroupUser(params).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.initTableData()
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 新增
    handleAdd () {
      this.$refs.editModal.open(true)
    },
    // 批量移除
    handleDel () {
      const searchModel = this.selectedRows
      console.log(this.selectedRows)
      if (!searchModel || searchModel.length === 0) {
        this.$message.error('请至少选择一行数据进行移除！')
        return
      }
      this.$confirm({
        title: `【${this.groupName}】人员移除`,
        content: (h) => {
          let users = ''
          for (const i in this.selectedRows) {
            users += `【${this.selectedRows[i].userName}】`
          }
          return `确定要移除${users}吗？`
        },
        onOk: (e) => this.batchDel(e),
        onCancel () {}
      })
    },
    // 批量移除接口
    batchDel (e) {
      const searchModels = this.selectedRows
      let userIds = ''
      searchModels.map(item => {
        userIds += item.userId + ','
      })
      const params = {
        groupId: this.groupId,
        userIds: userIds
      }
      deleteGroupUser(params).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.initTableData()
          this.selectedRows = []
          e()
        } else {
          this.$message.error(res.info.message)
          e()
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
